export const GET_SIGNED_USER = "GET_SIGNED_USER";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const GET_USERS="GET_USERS";
export const GET_USER="GET_USER";
export const RESET_APP="RESET_APP";


